import { connect } from 'react-redux';
import View from './EmergencyFundView';
import MobileView from '../../MobileFinancialPlan/MobileEmergencyFund/MobileEmergencyFundView';
import { setReactCalibrationWidget } from '../FinancialPlanActions';
import { calibration, data as dataSelector } from '../FinancialPlanSelector';
import {
  goalId,
  goalViewState as goalViewStateSelector,
} from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { getGoal } from '../FinancialPlanHelpers';
import { isCurrentPlanSelector } from '../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';
import { OVERVIEW } from '../Explanations/ExplanationsConst';

const mapStateToProps = (state, ownProps) => {
  const data = dataSelector(state, ownProps);
  const goal = getGoal(data, goalId(state, ownProps));

  let emergencyFundGoal;

  if (goal.GoalType === 'emergencyfund') {
    emergencyFundGoal = goal;
  }

  if (ownProps.isPrint) {
    emergencyFundGoal = ownProps.goal;
  }

  const selectedSection = goalViewStateSelector(state, ownProps).selectedSection || OVERVIEW;

  return {
    calibration: calibration(state, ownProps),
    goalId: goal.GoalId,
    emergencyFundGoal,
    data,
    isCurrentPlan: isCurrentPlanSelector(state, ownProps),
    selectedSection,
    assumptionsValues: goal.GoalAssumptions,
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibration, clientId) => {
    dispatch(setReactCalibrationWidget(calibration, clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);

export const MobileEmergencyFund = connect(mapStateToProps, mapDispatchToProps)(MobileView);
